/**
 * Owl Carousel for carousels
 */
import 'owl.carousel';

/**
 * parses div class lists and returns carousel types
 * @param {NodeListOf<Element>} divs
 * @returns {array}
 */
export let parseCarouselClassLists = (divs) => {
  let carouselTypes = [];
  let divsLength = divs.length;

  if (divsLength > 1) {
    //loop through all the divs
    for (let i = divsLength; i--;) {
      let classLength = divs[i].classList.length;

      //loop through their classLists
      for (let j = classLength; j--;) {
        if (divs[i].classList[j].startsWith('js-carousel') === true) {
          //add type of carousel from the div class name
          carouselTypes.push(divs[i].classList[j].split('-')[2]);
        }
      }
    }
  } else {
    let classLength = divs[0].classList.length;

    //only one div so loop through classlist
    for (let j = classLength; j--;) {
      if (divs[0].classList[j].startsWith('js-carousel') === true) {
        //add type of carousel from the div class name
        carouselTypes.push(divs[0].classList[j].split('-')[2]);
      }
    }
  }

  return carouselTypes;
}

/**
 * selects carousel properties according to the class parsed from
 * carouselParseClassLists() and initializes necessary carousels
 * @param carouselArray
 * @param $
 */
export let setCarouselProps = (carouselArray) => {
  //set scope to access child objects by variable name in carouselArray
  let scope = {};
  //carousel settings for each type of carousel
    scope.testimonial = {
      items: 1,
      loop: true,
      margin: 10,
      lazyLoad: true,
      center: true,
      autoHeight: true,
    };

  /*scope.fourUp = {
    dots: false,
    nav: true,
    navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
    margin: 30,
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
      },
      640: {
        items: 3,
      },
      768: {
        items: 4,
      }
    }
  };

  scope.relatedBooks = {
    items: 5,
    margin: 10,
    autoHeight: true,
  };*/

  scope.timeline = {
    margin: 0,
    autoHeight: true,
    responsiveClass: true,
    nav: false,
    responsive: {
      0: {
        items: 3,
      },
      768: {
        items: 6,
      },
      1280: {
        items: 9,
      }
    },
  };

  //remove duplicates from array
  //only need to initialize once for each type
  carouselArray = [...new Set(carouselArray)];
  let carouselLength = carouselArray.length;

  //loop through array and initialize carousels accordingly
  for (let i = carouselLength; i--;) {
    jQuery(`.js-carousel-${carouselArray[i]}`).owlCarousel(scope[carouselArray[i]]);
  }
}
